import Button from "../../components/Button";
import { InputNumber } from "../../components/InputNumber";
import { NewUcInput } from "../../components/NewUcInput";
import { useUcSearchScreen } from "./useUcSearchScreen";
import invoice from "../../assets/invoice.png";
import invoice2 from "../../assets/invoice2.png";
import { Dialog } from "primereact/dialog";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";

import styles from "./styles.module.css";

const PUBLIC_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LdxJrMrAAAAAA5ziA195iyoRJ_kDRlz91blurai";

export function UcSearchScreen() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={PUBLIC_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <UcSearchScreenContent />
    </GoogleReCaptchaProvider>
  );
}

function UcSearchScreenContent() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const hook = useUcSearchScreen(executeRecaptcha || null);

  return (
    <>
      <div className="app-body">
        <div className="w-full">
          <form onSubmit={hook.handleSubmit} autoComplete="off">
            <div className="flex justify-content-between mb-5">
              <fieldset className="flex flex-column gap-4 align-items-center">
                <InputNumber
                  label="Unidade consumidora"
                  placeholder="999999999999"
                  onChange={(e) => hook.handleOldUcChange(e)}
                  name="oldUc"
                  value={hook.oldUc}
                />
                <NewUcInput
                  label="Novo número"
                  placeholder="9.999.999.999.031-99 (15 díg.)"
                  onChange={hook.handleNewUcChange}
                  name="newUc"
                  value={hook.newUc}
                />
              </fieldset>

              <fieldset className="flex flex-column gap-6 align-items-center">
                <Button
                  label="Pesquisar"
                  type="submit"
                  className="mt-3"
                  disabled={hook.buttonDisabled}
                />
                <Button
                  label="Limpar"
                  type="button"
                  onClick={hook.handleClean}
                  secondary
                />
              </fieldset>
            </div>
            {/* O reCAPTCHA v3 é invisível, então removemos o componente visível */}
          </form>

          <Button
            label="Não sabe onde encontrar o número da unidade consumidora? Clique aqui"
            type="button"
            onClick={() => hook.setShowInvoiceModal(true)}
            className="mt-8"
            secondary
          />
        </div>
      </div>

      <Dialog
        className={`${styles.dialog}`}
        header="Onde encontrar o número da unidade consumidora:"
        visible={hook.showInvoiceModal}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!hook.showInvoiceModal) return;
          hook.setShowInvoiceModal(false);
        }}
      >
        <>
          <img className="invoice-image" alt="invoice" src={invoice} />
          <img className="invoice-image" alt="invoice2" src={invoice2} />
        </>
      </Dialog>
    </>
  );
}
